import { render } from "./UsoPracticas.vue?vue&type=template&id=68e7df75&scoped=true"
import script from "./UsoPracticas.vue?vue&type=script&lang=js"
export * from "./UsoPracticas.vue?vue&type=script&lang=js"

import "./UsoPracticas.vue?vue&type=style&index=0&id=68e7df75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e7df75"]])

export default __exports__